import styled from 'styled-components';

export const DataBasePageConteiner = styled.div`
  padding-left: 100px;
  padding-top: 65px;

`;
export const Container = styled.div`
display:flex;
`;